export const name: string = 'Create Link';
export const group = 'Misc.';
export const moduleName: string = 'pdc-widget-create-link';
export const icon: string = 'link';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-create-link';

export const themeFields = {
    promptDialogTitile: 'widget-action-button-prompt-dialog-title',
    promptDialogText: 'widget-action-button-prompt-dialog-text'
};
